import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useArticles } from "@faire/help-center-utils/hooks/article/useArticles";
import { useAssignSettingSelfServeBrandInstantAnswers, useSettingSelfServeBrandInstantAnswers } from "@faire/help-center-utils/settings/useSettingSelfServiceBrandInstantAnswers";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { Synchronized } from "@faire/web--source/slate/icons/foundation/Synchronized";
import React from "react";
export var useIntegrationsBrandNodes = function useIntegrationsBrandNodes() {
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var enableSettingSelfServeBrandInstantAnswers = useSettingSelfServeBrandInstantAnswers();
  var assignSettingSelfServeBrandInstantAnswers = useAssignSettingSelfServeBrandInstantAnswers();
  var articles = useArticles();
  var commonFields = {
    id: "Integrations",
    label: strictLocalize({
      id: "oogQe8",
      defaultMessage: [{
        "type": 0,
        "value": "Integraties"
      }]
    }),
    icon: /*#__PURE__*/React.createElement(Synchronized, {
      fontSize: "24px",
      color: "faireBlack"
    }),
    articles: [articles.Integration.SOFTWARE_INTEGRATION_WITH_FAIRE, articles.Integration.ONBOARDING_WITH_SHOPIFY, articles.Integration.CAN_I_INTEGRATE_WITH_SHOPIFY],
    level: 1,
    assignSetting: assignSettingSelfServeBrandInstantAnswers,
    sidebarTitle: strictLocalize({
      id: "nD5YF3",
      defaultMessage: [{
        "type": 0,
        "value": "Integratieprobleem"
      }]
    })
  };
  if (!enableSettingSelfServeBrandInstantAnswers) {
    return {
      Integrations: _objectSpread({}, commonFields)
    };
  }
  return {
    Integrations: _objectSpread(_objectSpread({}, commonFields), {}, {
      children: ["AboutIntegrations", "ProductImportWithShopify", "InventorySyncWithShopify", "PricingSyncWithShopify", "OrderSyncWithShopify", "SetUpIntegration", "ConnectToApi", "RequestIntegration"]
    }),
    AboutIntegrations: {
      id: "AboutIntegrations",
      label: strictLocalize({
        id: "69iEEA",
        defaultMessage: [{
          "type": 0,
          "value": "Over integraties"
        }]
      }),
      level: 2
    },
    ProductImportWithShopify: {
      id: "ProductImportWithShopify",
      label: strictLocalize({
        id: "M1LJNi",
        defaultMessage: [{
          "type": 0,
          "value": "Productimport met Shopify"
        }]
      }),
      level: 2
    },
    InventorySyncWithShopify: {
      id: "InventorySyncWithShopify",
      label: strictLocalize({
        id: "VVyNJn",
        defaultMessage: [{
          "type": 0,
          "value": "Voorraadsynchronisatie met Shopify"
        }]
      }),
      level: 2
    },
    PricingSyncWithShopify: {
      id: "PricingSyncWithShopify",
      label: strictLocalize({
        id: "Ch0BHt",
        defaultMessage: [{
          "type": 0,
          "value": "Prijssynchronisatie met Shopify"
        }]
      }),
      level: 2
    },
    OrderSyncWithShopify: {
      id: "OrderSyncWithShopify",
      label: strictLocalize({
        id: "6mZqD4",
        defaultMessage: [{
          "type": 0,
          "value": "Bestellingsynchronisatie met Shopify"
        }]
      }),
      level: 2
    },
    SetUpIntegration: {
      id: "SetUpIntegration",
      label: strictLocalize({
        id: "xzoFup",
        defaultMessage: [{
          "type": 0,
          "value": "Integratie instellen"
        }]
      }),
      level: 2
    },
    ConnectToApi: {
      id: "ConnectToApi",
      label: strictLocalize({
        id: "bLqI+g",
        defaultMessage: [{
          "type": 0,
          "value": "Koppelen met API"
        }]
      }),
      level: 2
    },
    RequestIntegration: {
      id: "RequestIntegration",
      label: strictLocalize({
        id: "55mOvI",
        defaultMessage: [{
          "type": 0,
          "value": "Integratie aanvragen"
        }]
      }),
      level: 2
    }
  };
};